import { Box, Button, Grid, Tab, Tabs,Typography } from "@mui/material";
import PropTypes from 'prop-types';
import React from "react";
import CompletedLaunchpad from "./CompletedLaunchpad";
import UpcommingLaunchpad from "./UpcommingLaunchpad";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <Box
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            {children}
          </Box>
        )}
      </Box>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

const MainLaunchpad = () => {
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
  return (
    <Grid coontainer>
      <Grid item lg={12} md={12} xl={12} sm={12} xs={12}>
        <Tabs centered value={value} onChange={handleChange} TabIndicatorProps={{style:{}}}>
        <Tab label="Upcomming" {...a11yProps(0)} sx={{color:'white',backgroundColor:'black',border: '2px dotted #2f6df6',borderRadius:'20px',margin:'5px',"&:active":{backgroundColor:'#2f6df6',color:'white'}}} />
          <Tab label="Completed" {...a11yProps(1)} sx={{color:'white',backgroundColor:'black',border: '2px dotted #2f6df6',borderRadius:'20px',margin:'5px',"&:active":{backgroundColor:'#2f6df6',color:'white'}}}/>
        </Tabs>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TabPanel value={value} index={0}>
            <UpcommingLaunchpad />
        </TabPanel>
        <TabPanel value={value} index={1}>
        <CompletedLaunchpad />
        </TabPanel>
        </Grid> 
    </Grid>
  );
};

export default MainLaunchpad;
